import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

import { SectionShimmer } from './section-shimmer';
import { RadiusShimmer } from './radius-shimmer';

export const DateSettingsShimmer = () => (
  <>
    <RadiusShimmer />
    <Shimmer shimmerElements={[{ type: ShimmerElementType.gap, width: '100%', height: 24 }]} />
    <SectionShimmer />
    <Shimmer shimmerElements={[{ type: ShimmerElementType.gap, width: '100%', height: 12 }]} />
    <SectionShimmer />
  </>
);
